import React from "react";
import styled from "styled-components";

import { get, responsiveImg } from "package-common-react/lib/style/util";

export const GameLink = styled(function({
  size,
  className,
  href,
  title,
  src,
  ...props
}) {
  return (
    <a title={title} className={className} href={href}>
      <img src={src} alt={title} {...props} />
    </a>
  );
})`
  background: ${get('color.blue')};
  border: 8px solid #FFF;
  border-radius: 16px;
  display: inline-block;
  line-height: 0;
  margin: 10px;
  padding: 10px 15px;
  width: 80px;

  img {
    ${responsiveImg()};
  }
`;



// WEBPACK FOOTER //
// ./src/components/GamesLinks/style.js